"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NAV_MENUS = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _appRulesResolver = require("@match/app-rules-resolver");

var _Box = _interopRequireDefault(require("@match/react-component-library/components/Box"));

var _abtests = _interopRequireDefault(require("../../constants/abtests"));

var _components = require("../../components");

var _eventsMenu = _interopRequireDefault(require("./events-menu"));

var _interestMenu = _interopRequireDefault(require("./interest-menu"));

var _mutualInboxMenu = _interopRequireDefault(require("./mutual-inbox-menu"));

var _profileMenu = _interopRequireDefault(require("./profile-menu"));

var _recommendedMenu = _interopRequireDefault(require("./recommended-menu"));

var _searchMenu = _interopRequireDefault(require("./search-menu"));

var _settingsMenu = _interopRequireDefault(require("./settings-menu"));

var NAV_MENUS = {
  HOME: 'home',
  DISCOVER: 'discover',
  INTERESTS: 'interests',
  MATCH_EVENTS: 'matchEvents',
  MUTUAL_INBOX: 'mutualInbox',
  PROFILE_SELF: 'profileSelf',
  SETTINGS: 'settings'
};
exports.NAV_MENUS = NAV_MENUS;

var TopNavMenuLayout = function TopNavMenuLayout(_ref) {
  var _ref$activeListItem = _ref.activeListItem,
      activeListItem = _ref$activeListItem === void 0 ? '' : _ref$activeListItem,
      _ref$canReactivate = _ref.canReactivate,
      canReactivate = _ref$canReactivate === void 0 ? false : _ref$canReactivate,
      customLinkRenderer = _ref.customLinkRenderer,
      _ref$eliteBenefitsCou = _ref.eliteBenefitsCount,
      eliteBenefitsCount = _ref$eliteBenefitsCou === void 0 ? 0 : _ref$eliteBenefitsCou,
      featureFlags = _ref.featureFlags,
      _ref$shouldShowPowerU = _ref.shouldShowPowerUpButton,
      shouldShowPowerUpButton = _ref$shouldShowPowerU === void 0 ? false : _ref$shouldShowPowerU,
      _ref$isEliteSub = _ref.isEliteSub,
      isEliteSub = _ref$isEliteSub === void 0 ? false : _ref$isEliteSub,
      isInABTest = _ref.isInABTest,
      _ref$isLoggedIn = _ref.isLoggedIn,
      isLoggedIn = _ref$isLoggedIn === void 0 ? false : _ref$isLoggedIn,
      _ref$isPremiumSub = _ref.isPremiumSub,
      isPremiumSub = _ref$isPremiumSub === void 0 ? false : _ref$isPremiumSub,
      _ref$isSubscriber = _ref.isSubscriber,
      isSubscriber = _ref$isSubscriber === void 0 ? false : _ref$isSubscriber,
      _ref$isUnauthorizedTo = _ref.isUnauthorizedToSendMessages,
      isUnauthorizedToSendMessages = _ref$isUnauthorizedTo === void 0 ? false : _ref$isUnauthorizedTo,
      isUpgradeToPremiumEligible = _ref.isUpgradeToPremiumEligible,
      _ref$mutualInboxCount = _ref.mutualInboxCount,
      mutualInboxCount = _ref$mutualInboxCount === void 0 ? 0 : _ref$mutualInboxCount,
      _ref$mutualInboxHidde = _ref.mutualInboxHiddenCount,
      mutualInboxHiddenCount = _ref$mutualInboxHidde === void 0 ? 0 : _ref$mutualInboxHidde,
      _ref$newLikesCount = _ref.newLikesCount,
      newLikesCount = _ref$newLikesCount === void 0 ? 0 : _ref$newLikesCount,
      _ref$newViewedMeCount = _ref.newViewedMeCount,
      newViewedMeCount = _ref$newViewedMeCount === void 0 ? 0 : _ref$newViewedMeCount,
      _ref$primaryPhotoUri = _ref.primaryPhotoUri,
      primaryPhotoUri = _ref$primaryPhotoUri === void 0 ? '' : _ref$primaryPhotoUri,
      siteCode = _ref.siteCode,
      siteName = _ref.siteName,
      _ref$subscriberBenefi = _ref.subscriberBenefitsCount,
      subscriberBenefitsCount = _ref$subscriberBenefi === void 0 ? 0 : _ref$subscriberBenefi;

  var _React$useState = _react.default.useState(undefined),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      activeHoverItem = _React$useState2[0],
      onUpdateActiveHoverItem = _React$useState2[1];

  if (!isLoggedIn) {
    return _react.default.createElement(_components.Banner, {
      className: "topnavmenu"
    }, _react.default.createElement(_Box.default, {
      display: "flex",
      justifyContent: "space-between",
      width: 1020
    }, _react.default.createElement(_components.LogoWithNav, {
      siteName: siteName,
      customLinkRenderer: customLinkRenderer
    })));
  }

  var handleItemMouseEnter = function handleItemMouseEnter(updateActiveHoverItem) {
    return function (id) {
      updateActiveHoverItem(id);
    };
  };

  var handleItemMouseLeave = function handleItemMouseLeave(updateActiveHoverItem) {
    return function () {
      updateActiveHoverItem(undefined);
    };
  };

  var isNeedingValidIdCertifcate = featureFlags[_appRulesResolver.FEATURE_FLAGS.SHOW_CERTIFICATES] && isUnauthorizedToSendMessages;
  var showSearchNav = !isInABTest(_abtests.default.DESKTOP.stirRemoveSearch);
  var showWVM = isLoggedIn && !isInABTest(_abtests.default.DESKTOP.removeWVM); // Stir (SC10) has both Events and Search removed, thus creating a very large gap between the nav items.

  var navWidth = !featureFlags[_appRulesResolver.FEATURE_FLAGS.MATCH_EVENTS] && !showSearchNav ? 218 : 416;
  var isStir = siteCode === _appRulesResolver.SITECODE.STIR;
  var showSubMenu = !isStir;
  return _react.default.createElement(_components.Banner, {
    className: "topnavmenu"
  }, _react.default.createElement(_Box.default, {
    display: "flex",
    justifyContent: "space-between",
    width: 1020
  }, _react.default.createElement(_components.LogoWithNav, {
    siteName: siteName,
    customLinkRenderer: customLinkRenderer
  }), _react.default.createElement(_Box.default, {
    as: "ul",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: navWidth,
    role: "list"
  }, _react.default.createElement(_recommendedMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    customLinkRenderer: customLinkRenderer,
    isLoggedIn: isLoggedIn,
    isSubscriber: isSubscriber,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem)
  }), showSearchNav && _react.default.createElement(_searchMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    customLinkRenderer: customLinkRenderer,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem),
    isSubscriber: isSubscriber,
    isLoggedIn: isLoggedIn
  }), _react.default.createElement(_interestMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    count: newLikesCount,
    customLinkRenderer: customLinkRenderer,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem),
    isSubscriber: isSubscriber,
    showPhonebook: isLoggedIn && featureFlags[_appRulesResolver.FEATURE_FLAGS.MATCH_PHONE],
    showSubMenu: showSubMenu
  }), _react.default.createElement(_mutualInboxMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    altCount: mutualInboxHiddenCount,
    count: mutualInboxCount,
    customLinkRenderer: customLinkRenderer,
    isSubscriber: isSubscriber,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem)
  }), featureFlags[_appRulesResolver.FEATURE_FLAGS.MATCH_EVENTS] && _react.default.createElement(_eventsMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    customLinkRenderer: customLinkRenderer,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem),
    isSubscriber: isSubscriber
  })), _react.default.createElement(_Box.default, {
    as: "ul",
    role: "list",
    display: "flex",
    alignItems: "center"
  }, _react.default.createElement(_components.PowerUpButton, {
    isSubscriber: isSubscriber,
    isNeedingValidIdCertifcate: isNeedingValidIdCertifcate,
    canReactivate: canReactivate,
    shouldShowPowerUpButton: shouldShowPowerUpButton
  }), _react.default.createElement(_profileMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    customLinkRenderer: customLinkRenderer,
    isSubscriber: isSubscriber,
    eliteBenefitsCount: eliteBenefitsCount,
    showEliteBenefits: featureFlags[_appRulesResolver.FEATURE_FLAGS.SUBSCRIPTION_BENEFITS] && isEliteSub,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem),
    primaryPhotoUri: primaryPhotoUri,
    subscriberBenefitsCount: subscriberBenefitsCount,
    totalCount: newViewedMeCount,
    viewedMeCount: newViewedMeCount,
    showBoost: isLoggedIn,
    showSafetyCenter: featureFlags[_appRulesResolver.FEATURE_FLAGS.SAFETY_CENTER] && isLoggedIn,
    showSubscriberBenefits: featureFlags[_appRulesResolver.FEATURE_FLAGS.SUBSCRIPTION_BENEFITS] && isPremiumSub && !isEliteSub,
    showViewedMe: showWVM,
    isUpgradeToPremiumEligible: isUpgradeToPremiumEligible
  }), _react.default.createElement(_settingsMenu.default, {
    activeHoverListItem: activeHoverItem,
    activeListItem: activeListItem,
    customLinkRenderer: customLinkRenderer,
    isLoggedIn: isLoggedIn,
    isSubscriber: isSubscriber,
    onItemMouseEnter: handleItemMouseEnter(onUpdateActiveHoverItem),
    onItemMouseLeave: handleItemMouseLeave(onUpdateActiveHoverItem)
  }))));
};

var _default = TopNavMenuLayout;
exports.default = _default;